import { isOverMaxAge, isUnderMinAge } from '../utils/validation/isValidBirthDate';
import { findErrorsInModel } from '../utils/validation/findErrorsInModel';
import { validationMessages } from '../constants/validation/personalDetails';
import { isValidInput } from '../utils/validation/isValidInput';
import { validateTitle } from '../utils/validation/validateTitle';
import moment from 'moment';

const GENDERS = ['M', 'F'];

function isGenderFieldValid(model) {
  const { genderError, titleMismatchError } = validationMessages;
  return function isGenderFieldValid(gender) {
    if (!GENDERS.includes(gender)) {
      return genderError;
    }
    if (gender !== '' && model && model.name && !validateTitle(model.name.title, gender)) {
      return titleMismatchError;
    }
  };
}

function isTitleFieldValid(model) {
  const { titleError, titleMismatchError } = validationMessages;
  return function isTitleFieldValid(title) {
    if (title === '') {
      return titleError;
    }
    if (title !== '' && model && !validateTitle(title, model.gender)) {
      return titleMismatchError;
    }
  };
}

function getSchema(model) {
  const {
    firstNameError,
    middleNameError,
    lastNameError,
    birthDate: { dobError, minimumAgeError, maximumAgeError },
    noOfDependentError,
    UKCitizenshipError,
    otherCountryCitizenshipError,
    emailAddressError,
    mobileNumberError
  } = validationMessages;

  return {
    name: {
      title: isTitleFieldValid(model),
      firstName: (firstName) =>
        (firstName === '' && firstNameError) ||
        (!isValidInput(firstName, 'AlphabetTwoSpace') && firstNameError) ||
        (firstName !== '' && firstName.length < 1 && firstNameError) ||
        (firstName !== '' && firstName.length > 35 && firstNameError),
      middleName: (middleName) =>
        (middleName !== '' && !isValidInput(middleName, 'Alphabet') && middleNameError) ||
        (middleName !== '' && middleName.length > 12 && middleNameError),
      lastName: (lastName) =>
        (lastName === '' && lastNameError) ||
        (!isValidInput(lastName, 'Alphabet') && lastNameError) ||
        (lastName !== '' && lastName.length < 1 && lastNameError) ||
        (lastName !== '' && lastName.length > 25 && lastNameError)
    },
    birthDate: (birthDate) => {
      if (birthDate === '') {
        return dobError;
      }
      if (!isUnderMinAge(moment(birthDate).format('YYYY-MM-DD'))) {
        return minimumAgeError;
      }
      if (!isOverMaxAge(moment(birthDate).format('YYYY-MM-DD'))) {
        return maximumAgeError;
      }
    },
    gender: isGenderFieldValid(model),
    numberOfDependants: (numberOfDependants) => numberOfDependants === '' && noOfDependentError,
    UKCitizenship: (value) => value === '' && UKCitizenshipError,
    otherCountry: (value) => {
      if (model && model.UKCitizenship === 'N' && (value === '' || value === 'Please select')) {
        return otherCountryCitizenshipError;
      }
    },
    emailAddress: (value) => {
      const MIN_EMAIL_LENGTH = 6;
      const MAX_EMAIL_LENGTH = 70;
      return (
        (value === '' && emailAddressError) ||
        (value.length < MIN_EMAIL_LENGTH && emailAddressError) ||
        (value.length > MAX_EMAIL_LENGTH && emailAddressError) ||
        (!isValidInput(value, 'Email') && emailAddressError)
      );
    },
    mobileNumber: (value) =>
      (value === '' && mobileNumberError) ||
      (value !== '' && !isValidInput(value, 'Mobile') && mobileNumberError)
  };
}

export const validateModel = (model) => {
  const foundErrors = findErrorsInModel(model, getSchema(model));
  return foundErrors;
};

export const validateFormField = (field, value, section) => {
  const schema = getSchema();
  if (section) {
    return schema[section][field] && schema[section][field](value);
  }
  return schema[field] && schema[field](value);
};
